import { Eyebrow, Reveal } from "./Primitives";

export const About = () => (
  <section id="ueber-uns" data-testid="about-section" className="bg-white py-24 sm:py-32">
    <div className="mx-auto grid max-w-[1400px] gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:items-center lg:px-12">
      <Reveal className="lg:col-span-5">
        <figure className="relative aspect-[4/5] overflow-hidden bg-ice">
          <img src="/images/under2.webp" alt="Kind schwimmt unter Wasser in einem hellblauen Becken" loading="lazy" className="h-full w-full object-cover" />
          <div className="absolute -bottom-px -right-px bg-navy px-6 py-4">
            <img src="/images/manta-logo.png" alt="" aria-hidden="true" className="h-7 w-auto" />
          </div>
        </figure>
      </Reveal>
      <div className="lg:col-span-6 lg:col-start-7">
        <Reveal>
          <Eyebrow>Über uns</Eyebrow>
          <h2 className="mt-6 text-4xl font-extrabold leading-[1.05] tracking-[-0.02em] text-navy sm:text-5xl">
            Mit Leidenschaft für mehr <span className="font-light italic text-sky-700">Sicherheit im Wasser.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 text-base leading-relaxed text-slate-600 md:text-lg">
            Schwimmschule Manta ist eine Schwimmschule für Kinder und Jugendliche in Darmstadt, Dieburg und Umgebung. Uns ist wichtig, dass Kinder mit Freude ins Wasser gehen, Schritt für Schritt sicherer werden und dabei echtes Selbstvertrauen entwickeln.
          </p>
          <p className="mt-5 text-base leading-relaxed text-slate-600 md:text-lg">
            Über den Elternbereich behalten Familien Kurse, Anwesenheit und den Fortschritt ihres Kindes bei den Schwimmabzeichen jederzeit im Blick.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
